import { environmentConfig } from "@src/appV2/environment/config";
import { DeploymentEnvironmentName } from "@src/appV2/environment/types";

import { isCbhEmployeeEmail } from "../isCbhEmployeeEmail";

export type SsoMode = "off" | "sso_only" | "sso_and_magic_link";

/**
 * Determines the SSO mode for the given email.
 *
 * - "sso_only": SSO is the only login option (production employees).
 * - "sso_and_magic_link": SSO button shown alongside magic link (non-production employees).
 * - "off": no SSO (non-employees, + aliases, _3p vendor accounts).
 */
export function getSsoMode(email: string): SsoMode {
  if (!isCbhEmployeeEmail(email)) {
    return "off";
  }

  const isProduction =
    environmentConfig.REACT_APP_ENVIRONMENT_NAME === DeploymentEnvironmentName.PRODUCTION;

  return isProduction ? "sso_only" : "sso_and_magic_link";
}
